import { createSlice } from "@reduxjs/toolkit";
import { getSpecialist, getNotification, getHelp, getQuestion } from "./action";
import { Specialist } from "~/types/specialist";
import { Notification } from "~/types/notification";
import { Question } from "~/types/question";
import { Help } from "~/types/help";

type DataState = {
  // 専門家
  isSpecialistInit: boolean;
  specialists: Specialist[];

  // 通知
  isNotificationInit: boolean;
  notifications: Notification[];

  // ヘルプ
  isHelpInit: boolean;
  helps: Help[];

  // 会話パターン
  isQuestionInit: boolean;
  questions: Question[];
};

const initialState: DataState = {
  // 専門家
  isSpecialistInit: false,
  specialists: [],

  // 通知
  isNotificationInit: false,
  notifications: [],

  // ヘルプ
  isHelpInit: false,
  helps: [],

  // 会話パターン
  isQuestionInit: false,
  questions: [],
};

const dataModule = createSlice({
  name: "admin/data",
  initialState,
  reducers: {
    initializeSpecialist(state) {
      state.isSpecialistInit = false;
    },
    initializeNotification(state) {
      state.isNotificationInit = false;
    },
    initializeHelp(state) {
      state.isHelpInit = false;
    },
    initializeQuestion(state) {
      state.isQuestionInit = false;
    },
  },
  extraReducers: (builder) => {
    // 専門家 取得
    builder.addCase(getSpecialist.pending, (state) => {
      // 処理時
      return {
        ...state,
        isSpecialistInit: false,
      };
    });
    builder.addCase(getSpecialist.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isSpecialistInit: true,
        specialists: [],
      };
    });
    builder.addCase(getSpecialist.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isSpecialistInit: true,
        specialists: action.payload,
      };
    });

    // 通知 取得
    builder.addCase(getNotification.pending, (state) => {
      // 処理時
      return {
        ...state,
        isNotificationInit: false,
      };
    });
    builder.addCase(getNotification.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isNotificationInit: true,
        notifications: [],
      };
    });
    builder.addCase(getNotification.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isNotificationInit: true,
        notifications: action.payload,
      };
    });

    // ヘルプ 取得
    builder.addCase(getHelp.pending, (state) => {
      // 処理時
      return {
        ...state,
        isHelpInit: false,
      };
    });
    builder.addCase(getHelp.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isHelpInit: true,
        helps: [],
      };
    });
    builder.addCase(getHelp.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isHelpInit: true,
        helps: action.payload,
      };
    });

    // 会話パターン 取得
    builder.addCase(getQuestion.pending, (state) => {
      // 処理時
      return {
        ...state,
        isQuestionInit: false,
      };
    });
    builder.addCase(getQuestion.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isQuestionInit: true,
        questions: [],
      };
    });
    builder.addCase(getQuestion.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isQuestionInit: true,
        questions: action.payload,
      };
    });
  },
});

export const {
  initializeSpecialist,
  initializeNotification,
  initializeQuestion,
  initializeHelp,
} = dataModule.actions;
export { getSpecialist, getNotification, getHelp, getQuestion } from "./action";

export default dataModule;
